export default "__VITE_PUBLIC_ASSET__4bd22f87__"